import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { ICrediserverPerson } from '../models/i-crediserver-person';
import { IPropertyRN } from '../models/i-property-rn';
import { IBussinessRN } from '../models/i-bussiness-rn';
import { IPersonTSE } from '../models/i-person-tse';
import { ApiResponse, BaseResponse } from '../models/responses';
import { StorageService } from './storage.service';
import { ITemplate } from '../models/i-template';
import { ITemplateDocument } from '../models/i-template-document';
import { ITemplateType } from '../models/i-template-type';
import { IDocumentType } from '../models/i-document-type';
import { IVehicleRN } from '../models/i-vehicle-rn';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private http: HttpClient, private storageService: StorageService) { 

  }

  GetDataTSE(card: string): Observable<ApiResponse<IPersonTSE>> {
    return this.http.get<ApiResponse<IPersonTSE>>(`${Constants.API_URL}api/Formatos/GetPersonTSE?card=${card}`)
  }

  GetDataRNFinca(userid:number, cardNumber: string, provincia: string, duplicate: string, horizontal: string, right: string): Observable<ApiResponse<IPropertyRN>> {
    return this.http.get<ApiResponse<IPropertyRN>>(
      `${Constants.API_URL}api/Formatos/GetPropertyRN?userid=${userid}&cardNumber=${cardNumber}&provincia=${provincia}${(duplicate)?"&duplicate="+duplicate:""}${(horizontal)?"&horizontal="+horizontal:""}${(right)?"&right="+right:""}`)
  }

  GetDataRNPersonaJuridica(userid:number, card_type: string, card_class: string, card_consecitive: string): Observable<ApiResponse<IBussinessRN>> {
    return this.http.get<ApiResponse<IBussinessRN>>(
      `${Constants.API_URL}api/Formatos/GetBussinessRN?userid=${userid}&card_type=${card_type}&card_class=${card_class}&card_consecutive=${card_consecitive}`)
  }

  GetCrediserverPersons(): Observable<ApiResponse<Map<string, ICrediserverPerson>>> {
    return this.http.get<ApiResponse<Map<string, ICrediserverPerson>>>(
      `${Constants.API_URL}api/Crediserver/GetCrediserverPersons`)
  }

  StoreTemplateDocument(TemplateDocument: ITemplateDocument, Text: string): Observable<ApiResponse<number>> {
    let TemplateDocumentAndText = {
      TemplateDocument: TemplateDocument,
      Text: Text
    }
    return this.http.post<ApiResponse<number>>(
      `${Constants.API_URL}api/Template/StoreTemplateDocument`, TemplateDocumentAndText)
  }

  StoreTemplate(Template: ITemplate): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(
      `${Constants.API_URL}api/Template/StoreTemplate`, Template)
  }

  GetTemplateDocumentById(Id: number): Observable<ApiResponse<ITemplateDocument>> {
    return this.http.get<ApiResponse<ITemplateDocument>>(
      `${Constants.API_URL}api/Template/GetTemplateDocumentById?Id=${Id}`)
  }

  GetTemplateTypes(): Observable<ApiResponse<ITemplateType[]>> {
    return this.http.get<ApiResponse<ITemplateType[]>>(
      `${Constants.API_URL}api/Template/GetTemplateTypes`)
  }

  GetTemplateDocumentsByTemplateId(TemplateId): Observable<ApiResponse<ITemplateDocument[]>> {
    return this.http.get<ApiResponse<ITemplateDocument[]>>(
      `${Constants.API_URL}api/Template/GetTemplateDocumentsByTemplateId?TemplateId=${TemplateId}`
    )
  }

  GetDocumentTypesByTemplate(TemplateTypeId): Observable<ApiResponse<IDocumentType[]>> {
    return this.http.get<ApiResponse<IDocumentType[]>>(
      `${Constants.API_URL}api/Template/GetDocumentTypesByTemplate?TemplateTypeId=${TemplateTypeId}`
    )
  }

  GetTemplateDocumentsCount(Name: string, CreateUser: string, UpdateUser: string, From: string, To: string, TemplateType: string): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(
      `${Constants.API_URL}api/Template/GetTemplateDocumentsCount?Filter=${Name}&Variable=bac.nombre_Fideicomiso&CreateUser=${CreateUser}&UpdateUser=${UpdateUser}&From=${From}&To=${To}&TemplateType=${TemplateType}`)
  }

  GetTemplateDocumentsPaged(Name: string, CreateUser: string, UpdateUser: string, From: string, To: string, TemplateType: string, Offset: number, PageSize: number): Observable<ApiResponse<ITemplateDocument[]>> {
    return this.http.get<ApiResponse<ITemplateDocument[]>>(
      `${Constants.API_URL}api/Template/GetTemplateDocumentsPaged?Filter=${Name}&Variable=bac.nombre_Fideicomiso&CreateUser=${CreateUser}&UpdateUser=${UpdateUser}&From=${From}&To=${To}&TemplateType=${TemplateType}&Offset=${Offset}&PageSize=${PageSize}`)
  }

  /**
   * Crear una solicitud http para los datos de un vehiculo desde el registro nacional mediante el api de consulta al registro
   * @param _userid Identificador del usuario actual
   * @param _cardPlate Número de placa del vehículo
   * @param _class Clase del vehículo
   * @param _code Código de la clase
   * @returns Observable para resolucion de la solicitud http
   */
  GetDataRNVehiculo(_userid:number, _cardPlate: string, _class: string, _code: string): Observable<ApiResponse<IVehicleRN>> {
    let encodingClass: string = encodeURIComponent(_class ?? '');
    let encodingCode: string = encodeURIComponent(_code ?? '');
    return this.http.get<ApiResponse<IVehicleRN>>(
      `${Constants.API_URL}api/Formatos/GetVehicleRN?userid=${_userid}&card_plate=${_cardPlate}&vechicle_class=${encodingClass}&class_code=${encodingCode}`)
  }
}
